export const getReturnButtonPath = (defaultPath: string, from?: string) =>
  from?.includes(defaultPath) ? from : defaultPath;
